// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"538":"6d4c1859","657":"db6013fc","670":"40ea5ac2"}[chunkId] + ".chunk.js";
};